import { useCallback, useState, useEffect } from "react";
import {loadStripe} from '@stripe/stripe-js';
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout
} from '@stripe/react-stripe-js';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate
} from "react-router-dom";

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
// This is your test public API key.
const stripePromise = loadStripe('pk_live_51PGDCKGgPrP8co0z3BggxYOWKirNpQE5ROJbuo9kQa2JzU6e2v6CFNiENOyQAfVJwx81hT1nkqT2A9UsUpSdZ9jF00Dpr5jkyJ')
//TEST KEY = pk_test_51PGDCKGgPrP8co0zrHbFreXjtApjtVkHWU5oGGlQETfECHbBGMdclmdoeJuVBrhpmpkAyk9NaPlkAcrfkXM5wSwJ001AzBY8fU

const CheckoutForm = () => {
  const fetchClientSecret = useCallback(() => {
    // Create a Checkout Session
    return fetch("/api/create-checkout-session", {
      method: "POST",
    })
      .then((res) => res.json())
      .then((data) => data.clientSecret);
  }, []);

  const options = {fetchClientSecret};

  return (
    <div id="checkout">
      <EmbeddedCheckoutProvider
        stripe={stripePromise}
        options={options}
      >
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  )
}

const Return = ({ onStatusChange }) => {
  const [status, setStatus] = useState(null);
  const [customerEmail, setCustomerEmail] = useState('');

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const sessionId = urlParams.get('session_id');

    fetch(`/api/session-status?session_id=${sessionId}`)
      .then((res) => res.json())
      .then((data) => {
        setStatus(data.status);
        setCustomerEmail(data.customer_email);
        // Pass status up to parent component
        onStatusChange(data.status);
      });
  }, [onStatusChange]);

  if (status === 'open') {
    return (
      <Navigate to="/checkout" />
    )
  }

  if (status === 'complete') {
    return (
      <section id="success">
        <p>
          We appreciate your business! A confirmation email will be sent to {customerEmail}.

          If you have any questions, please email <a href="mailto:support@rompconcierge.com">support@rompconcierge.com</a>.
        </p>
      </section>
    )
  }

  return null;
}

const StripeEmbedded = ({ onStatusChange }) => {
  return (
    <div className="StripeEmbedded">
      <Router>
        <Routes>
          <Route path="/" element={<CheckoutForm />} />
          <Route path="/return" element={<Return onStatusChange={onStatusChange} />} />
        </Routes>
      </Router>
    </div>
  )
}

export default StripeEmbedded;